{
  "MACROS": {
    "HEADER": "Макрос",
    "DESCRIPTION": "Макрос — это набор сохраненных действий, которые помогают агентам службы поддержки легко выполнять задачи. Агенты могут определить ряд действий, таких как добавление метки к беседе, отправка транскрипта электронной почты, обновление пользовательского атрибута и т. д., и выполнять их одним щелчком мыши.",
    "LEARN_MORE": "Узнать больше о макросах",
    "HEADER_BTN_TXT": "Добавить новый макрос",
    "HEADER_BTN_TXT_SAVE": "Сохранить макрос",
    "LOADING": "Получение макроса",
    "ERROR": "Что-то пошло не так. Попробуйте еще раз",
    "ORDER_INFO": "Макросы будут выполняться в том порядке, в котором вы добавите ваши действия. Вы можете изменить их порядок, перетаскивая их ручкой рядом с каждым узлом.",
    "ADD": {
      "FORM": {
        "NAME": {
          "LABEL": "Название макроса",
          "PLACEHOLDER": "Введите имя для макроса",
          "ERROR": "Имя обязательно для создания макроса"
        },
        "ACTIONS": {
          "LABEL": "Действия"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Макрос успешно добавлен",
        "ERROR_MESSAGE": "Не удается создать макрос, пожалуйста, повторите попытку позже"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Имя",
        "CREATED BY": "Создан",
        "LAST_UPDATED_BY": "Обновлено",
        "VISIBILITY": "Видимость"
      },
      "404": "Макросы не найдены"
    },
    "DELETE": {
      "TOOLTIP": "Удалить макрос",
      "CONFIRM": {
        "MESSAGE": "Вы точно хотите удалить ",
        "YES": "Да, удалить",
        "NO": "Нет"
      },
      "API": {
        "SUCCESS_MESSAGE": "Макрос успешно удален",
        "ERROR_MESSAGE": "Произошла ошибка при удалении макроса. Пожалуйста, повторите попытку позже"
      }
    },
    "EDIT": {
      "TOOLTIP": "Изменить макрос",
      "API": {
        "SUCCESS_MESSAGE": "Макрос успешно обновлен",
        "ERROR_MESSAGE": "Не удалось обновить Macro, пожалуйста, повторите попытку позже"
      }
    },
    "EDITOR": {
      "START_FLOW": "Начало потока",
      "END_FLOW": "Конец потока",
      "LOADING": "Получение макроса",
      "ADD_BTN_TOOLTIP": "Добавить новое действие",
      "DELETE_BTN_TOOLTIP": "Удалить действие",
      "VISIBILITY": {
        "LABEL": "Видимость макроса",
        "GLOBAL": {
          "LABEL": "Публичный",
          "DESCRIPTION": "Этот макрос доступен всем агентам на этом аккаунте."
        },
        "PERSONAL": {
          "LABEL": "Приватный",
          "DESCRIPTION": "Этот макрос будет приватным для вас и не будет доступен для других."
        }
      }
    },
    "EXECUTE": {
      "BUTTON_TOOLTIP": "Выполнение",
      "PREVIEW": "Предпросмотр макроса",
      "EXECUTED_SUCCESSFULLY": "Макрос успешно выполнен"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Необходимо ввести ключ атрибута",
      "FILTER_OPERATOR_REQUIRED": "Требуется оператор фильтра",
      "VALUE_REQUIRED": "Необходимо указать значение",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Значение должно быть между 1 и 998",
      "ACTION_PARAMETERS_REQUIRED": "Требуются параметры действий",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Требуется хотя бы одно условие",
      "ATLEAST_ONE_ACTION_REQUIRED": "Требуется хотя бы одно действие"
    },
    "ACTIONS": {
      "ASSIGN_TEAM": "Назначить команду",
      "ASSIGN_AGENT": "Назначить агента",
      "ADD_LABEL": "Добавить метку",
      "REMOVE_LABEL": "Удалить метку",
      "REMOVE_ASSIGNED_TEAM": "Снять назначенную команду",
      "SEND_EMAIL_TRANSCRIPT": "Отправить транскрипт по email",
      "MUTE_CONVERSATION": "Заглушить диалог",
      "SNOOZE_CONVERSATION": "Отложить диалог",
      "RESOLVE_CONVERSATION": "Решить диалог",
      "SEND_ATTACHMENT": "Отправить вложение",
      "SEND_MESSAGE": "Отправить сообщение",
      "CHANGE_PRIORITY": "Изменить приоритет",
      "ADD_PRIVATE_NOTE": "Добавить личную заметку",
      "SEND_WEBHOOK_EVENT": "Отправить событие вебхука"
    },
    "ACTION_VALUES": {
      "SELF": "Я"
    }
  }
}
